import HTTP from '../HTTP';

const URL_BASE = 'commun/Societe/';

export async function getAll(params) {
  const response = await HTTP.post(URL_BASE + 'PGetAllAsync', params);
  return response;
}

export async function getAllTotal() {
  const response = await getAll({ maxResultCount: 99 });
  return response;
}

export async function update(societe) {
  const response = await HTTP.put(URL_BASE + 'UpdateAsync', societe);
  return response;
}

export async function get(id) {
  const response = await HTTP.get(URL_BASE + 'GetAsync', { params: { id: id } });
  return response;
}

export async function fusionSocieteAsync(payload) {
  const response = await HTTP.post(URL_BASE + 'SocieteFusionAsync', payload);
  return response;
}
